module.exports = __webpack_public_path__ + "static/media/img_flipCards-03.d72b851b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/flipbox/img_flipCards-03.png
// module id = 438
// module chunks = 4